var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { show: _vm.show }, attrs: { id: "wh_swiper" } }, [
    _c("div", { staticClass: "swiper_main" }, [
      _c("div", { staticClass: "swiper-container" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.renew, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                ref: "swiper_slide",
                refInFor: true,
                staticClass: "swiper-slide",
                attrs: { mSerial: item.mSerial },
              },
              [
                _c("div", { staticClass: "slide_box" }, [
                  _c("div", {
                    staticClass: "edge",
                    class: "rarity_" + item.rarity,
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "slide_box_main",
                      style: {
                        backgroundImage:
                          "url(" +
                          require("../../../resources/images/warehouse/rarity" +
                            item.rarity +
                            ".png") +
                          ")",
                      },
                    },
                    [
                      _vm._m(0, true),
                      _c("div", { staticClass: "slide_data" }, [
                        _c("p", { class: "fc_" + item.rarity }, [
                          _vm._v("新物品"),
                        ]),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.itemName)),
                        ]),
                        _c("span", [_vm._v(_vm._s(item.price))]),
                      ]),
                      _c("div", { staticClass: "pic" }, [
                        _c("img", { attrs: { src: item.itemPic, alt: "" } }),
                      ]),
                    ]
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "swiper-button-prev" }, [_vm._v("1")]),
        _c("div", { staticClass: "swiper-button-next" }, [_vm._v("2")]),
      ]),
      _c("div", { staticClass: "swiper-pagination" }),
      _c("div", { staticClass: "swiper_operation" }, [
        _c("p", [
          _c("span", { on: { click: _vm.to_sell } }, [_vm._v("兑换")]),
          _c("span", { on: { click: _vm.close } }, [_vm._v("关闭")]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Diga" }, [
      _c("img", {
        attrs: {
          src: require("../../../resources/images/warehouse/Diga.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }